// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"c49a95ba","213":"30d505cb","453":"f615bc19","553":"40f84cdd","608":"4fa64823","698":"a338be66","715":"4e656b27"}[chunkId] + ".chunk.js";
};